<template>
  <!-- 走进武夷山 -->
  <div>
    <div class="comInfo">
      <div class="rowB">
        <div class="body">
          <div class="topTitle">{{ info.title }}</div>
          <div class="littleTitle">
            <span>发布日期：{{ info.showTime }}</span>
            <span style="margin-left:5px">信息来源：{{ info.source }}</span>
            <span style="margin-left:5px">阅读次数：{{ info.hits }}</span>
          </div>
          <div class="line"></div>
          <div class="leftBody">
            <div class="leftBodyFont">{{ info.desc }}</div>
          </div>
        </div>
      </div>
      <!-- 右边 -->
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:11px;">武夷山景区</div>
            <div style="margin-top:11px">天下难寻</div>
            <div style="margin-top:11px">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComInfo",
  props: ["info"],
  data() {
    return {};
  },

  methods: {}
};
</script>

<style scoped>
.comInfo {
  height: 924px;
  background: url(../../assets/image/logoBottom.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}
.comInfo .rowA {
  display: flex;
  flex-direction: row;
  margin-top: 6%;
  margin-left: 9.67%;
}
.comInfo .rowB {
  width: 100%;
  margin-top: 70px;
  margin-left: 12.23%;
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.comInfo .rowB .body {
}
.comInfo .rowB .body .line {
  width: 100%;
  height: 0px;
  border-top: 1px dashed #449088;
  opacity: 0.5;
  margin-top: 16px;
}

.comInfo .rowB .body .topTitle {
  line-height: 20px;
  font-size: 20px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #005a51;
}

.comInfo .rowB .body .littleTitle {
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #005a51;
  margin-top: 24px;
}

.comInfo .rowB .body .leftBody {
  margin-top: 20px;
  width: 100%;
  height: 700px;
  overflow-y: scroll;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #666666;
  text-indent: 2em;
  text-align: left;
}
.comInfo .rowB .body .leftBody .leftBodyFont {
  width: 97%;
  line-height: 30px;
}

.comInfo .rowB .body .footer {
  width: 100%;
  text-align: center;
  height: 60px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.comInfo .rowC {
  padding: 0px 7px 0px 7px;
  height: 286px;
  line-height: 17px;
  background: #d87001;
  color: #ffffff;
  margin-top: 29px;
  margin-left: 6.8%;
  margin-right: 20px;
}
.comInfo .rowB .topFont {
  font-size: 18px;
  font-family: "Microsoft YaHei";
  font-weight: bold;
  color: #333333;
  line-height: 18px;
  margin-bottom: 15px;
}
.comInfo .chinese {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  margin-left: 9px;
  width: 16px;
  font-size: 16px;
  font-weight: bold;
  color: #d87001;
}
.comInfo .english {
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: #c45b0e;
  writing-mode: vertical-rl;
  width: 16px;
  font-size: 14px;
  font-weight: bold;
  color: #d87001;
}
.leftBody::-webkit-scrollbar {
  width: 8px;
  /*height: 4px;*/
}
/* 滑块 */
.leftBody::-webkit-scrollbar-thumb {
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #ababab;
}
/* 滑槽 */
.leftBody::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/commonInfo.vue